import url from 'url';
import { createAction, createReducer } from 'redux-act';
import { selectCurrentId } from '@gandi/redux-sharing';
import { createResource } from '@gandi/resource/redux';
import { selectRaw } from './utils';
export const resource = createResource('billing.money.pay');
export const preparePSPCall = ({
  mean: {
    pay_url: payUrl,
    provider,
    code,
    key
  },
  order: {
    id: session
  },
  locale: lang,
  returnUrl,
  sharingId,
  context,
  label
}) => dispatch => {
  return dispatch(resource.createOne(payUrl, {
    paylabel: `${session}-${provider}-${code}${key ? `-${key}` : ''}-${lang}`,
    session,
    lang,
    return_url: returnUrl
  }, {
    label: label || `${session}.${sharingId}.${context}`,
    params: {
      sharing_id: sharingId
    },
    on200: response => response,
    not200: response => Promise.reject(response)
  }));
};
export const selectPSPCallParams = (state, options) => selectRaw(state).money[options.label];
export const extractPaymentParameters = value => {
  const [provider, code, key] = value.split('-');
  const paymentProductId = key.split(provider)[1] || key.split(code)[1];
  return {
    provider,
    code,
    key,
    paymentProductId: paymentProductId ? parseInt(paymentProductId, 10) : undefined
  };
};
export const setPaymentCallParams = createAction('[billing.money.setPaymentUrl] Store payment URL & params');
export const selectIsPaying = (state, {
  sharingId,
  orderId
}) => resource.selectIsCreatingOne(state, `${sharingId}.${orderId}`);
export const selectPaymentCallParams = state => selectRaw(state).money.paymentCallParams;
export const pay = (params, options = {
  sharingId: undefined,
  params: undefined
}) => (dispatch, getState) => {
  const sharingId = options.sharingId || selectCurrentId(getState());
  if (typeof sharingId !== 'string') {
    return Promise.reject(new Error('[billing.money] `pay` called without `sharingId` option' + ' nor @gandi/redux-sharing dep/state.'));
  }
  const {
    label,
    orderId,
    provider,
    code,
    key,
    locale,
    returnUrl
  } = params;
  const paymentUrl = url.parse(params.saveUrl || params.payUrl);
  const endpoint = `${paymentUrl.pathname.split('/api/v5').pop()}`;
  const extraParams = paymentUrl.query ? Object.fromEntries(new URLSearchParams(paymentUrl.query)) : {};
  const body = {
    paylabel: label || `${orderId}-${provider}-${code}${key ? `-${key}` : ''}-${locale}`,
    session: orderId,
    lang: locale,
    return_url: returnUrl,
    order_id: orderId
  };
  const resourceLabel = `${sharingId}.${orderId}`;
  return dispatch(resource.createOne(endpoint, body, {
    ...options,
    label: resourceLabel,
    params: {
      ...(options.params || {}),
      sharing_id: sharingId,
      ...extraParams
    },
    on2XX: response => response,
    not2XX: response => Promise.reject(response)
  }));
};
const reducer = createReducer({
  [resource.createOne.success.getType()]: (state, {
    response: {
      data
    }
  }, {
    label
  }) => ({
    ...state,
    [label]: data
  }),
  [setPaymentCallParams]: (state, payload) => ({
    ...state,
    paymentCallParams: !!payload.url && payload
  })
}, {});
export default reducer;